/* eslint-disable import/prefer-default-export */
export enum CampaignTargetingStrategy {
  CustomerId = 'customerId',
  Open = 'open',
  WalletId = 'walletId'
}
